import { IDLE, LOADING, SUCCESS } from '../../../../enums/states';
import { createReducer } from '../../utils/reducer';

import { TRANSACTIONS_STATS_FETCH, TRANSACTIONS_STATS_SUCCESS } from '../../../actions/dashboard/transactionsStats';

const initialState = {
  data: null,
  error: null,
  state: IDLE,
};

const handlers = {
  [TRANSACTIONS_STATS_FETCH]: (state) => {
    return {
      ...state,
      state: LOADING,
    };
  },
  [TRANSACTIONS_STATS_SUCCESS]: (state, action) => {
    return {
      ...state,
      state: SUCCESS,
      data: action.payload,
    };
  },
};

export default createReducer(initialState, handlers);
